import EastIcon from '@mui/icons-material/East';
import DifferencesPopover from './DifferencesPopover';
import IssuesPopover from './IssuesPopover';
import WarningsPopover from './WarningsPopover';
import { Checkbox, Popover } from '@mui/material';
import { useState } from 'react';
import { SHEET_PROVIDERS } from '../constantsArticleExcel';

const getNewFieldOrOldFieldOrEmpty = (obj = {}, field) => {
  let value = obj[field];
  if (value === null || value === undefined) {
    value = obj[`${field}Og`];
  }
  if (value === null || value === undefined) {
    value = '';
  }
  return value;
};

const getCellClass = (item, field) => {
  if (item?.type === 'edited' && item?.changedKeys?.includes(field)) return 'edited-cell';
  if (item?.type === 'with-issues' && item?.issues?.some((issue) => issue?.field === field)) return 'with-issues-cell';
  return '';
};

const ProvidersFormatsRow = ({ style, article, providerFormat, index, isSelected, onToggle, isDisabled }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  return (
    <tr
      style={style}
      className={
        providerFormat?.type === 'edited'
          ? 'edited'
          : providerFormat?.type === 'created'
          ? 'created'
          : providerFormat?.type === 'with-issues' && 'with-issues'
      }
    >
      <td>
        <div>
          <Checkbox size="small" checked={isSelected ?? false} onChange={onToggle} disabled={isDisabled} />
        </div>
      </td>
      <td className={getCellClass(providerFormat, 'codeArticle')}>
        <div>
          {providerFormat?.type === 'with-issues' && (
            <IssuesPopover
              issues={providerFormat?.issues}
              excelRow={providerFormat?.excelRow}
              excelSheet={providerFormat?.excelSheet}
            />
          )}
          <WarningsPopover warnings={providerFormat?.warnings} excelRow={providerFormat?._excelRow} excelSheet={SHEET_PROVIDERS} />
          <span
            style={{
              width: '100%',
            }}
            aria-owns={open ? `mouse-over-popover-${index}` : undefined}
            aria-haspopup="true"
            onMouseEnter={handlePopoverOpen}
            onMouseLeave={handlePopoverClose}
          >
            {getNewFieldOrOldFieldOrEmpty(providerFormat, 'codeArticle') || <i>vacio</i>}
          </span>

          <Popover
            id={`mouse-over-popover-${index}`}
            sx={{ pointerEvents: 'none' }}
            open={open}
            anchorEl={anchorEl}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'left',
            }}
            onClose={handlePopoverClose}
            disableRestoreFocus
          >
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',

                padding: '1rem',
              }}
            >
              <span>{article?.name}</span>
              <img
                src={
                  article?.imgFile
                    ? URL.createObjectURL(article?.imgFile)
                    : article?.imglink || article?.imgBase64 || '/Image_not_available.png'
                }
                alt="img"
                width="130rem"
              />
            </div>
          </Popover>
        </div>
      </td>
      <td className={getCellClass(providerFormat, 'codeFormat')}>
        <div>{getNewFieldOrOldFieldOrEmpty(providerFormat, 'codeFormat') || <i>vacio</i>}</div>
      </td>
      <td className={getCellClass(providerFormat, 'code')}>
        <div>
          {getNewFieldOrOldFieldOrEmpty(providerFormat, 'code') || <i>vacio</i>}
          <DifferencesPopover show={providerFormat?.type === 'edited' && providerFormat?.changedKeys?.includes('code')}>
            <div>
              <span>{providerFormat?.codeOg}</span> <EastIcon /> <span>{providerFormat?.code}</span>
            </div>
          </DifferencesPopover>
        </div>
      </td>
      <td className={getCellClass(providerFormat, 'providerName')}>
        <div>
          {getNewFieldOrOldFieldOrEmpty(providerFormat, 'providerName') || <i>vacio</i>}
          <DifferencesPopover
            show={providerFormat?.type === 'edited' && providerFormat?.changedKeys?.includes('providerName')}
          >
            <div>
              <span>{providerFormat?.providerNameOg}</span> <EastIcon /> <span>{providerFormat?.providerName}</span>
            </div>
          </DifferencesPopover>
        </div>
      </td>
      <td className={getCellClass(providerFormat, 'price')}>
        <div>
          {Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(
            getNewFieldOrOldFieldOrEmpty(providerFormat, 'price'),
          )}
          <DifferencesPopover
            show={providerFormat?.type === 'edited' && providerFormat?.changedKeys?.includes('price')}
          >
            <div>
              <span>
                {Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(providerFormat?.priceOg)}
              </span>{' '}
              <EastIcon />{' '}
              <span>
                {Intl.NumberFormat('es-ES', { style: 'currency', currency: 'EUR' }).format(providerFormat?.price)}
              </span>
            </div>
          </DifferencesPopover>
        </div>
      </td>
      <td className={getCellClass(providerFormat, 'active')}>
        <div>{getNewFieldOrOldFieldOrEmpty(providerFormat, 'active') === true ? 'SI' : 'NO'}</div>
      </td>
    </tr>
  );
};

export default ProvidersFormatsRow;
